<template>
  <a-modal
    :title="title"
    :visible="visible"
    @ok="ok"
    @cancel="cancel"
    :footer="false"
    okText='确定'
    cancelText='取消'
    destroyOnClose 
    :maskClosable="false"
    width="900px"
  >
    <div>
      <span style="margin-right: 80px;"><span>EBS执行时间：</span>{{ time }}</span>
      <!-- <span><span>EBS产品名称：</span>{{ productName }}</span> -->
    </div>
    <h3 style="font-size: 14px;margin-top: 10px;font-weight: bold;">产品信息</h3>
    <a-table :columns="productColumns" :data-source="productList" :pagination="false" :scroll="{y: 300}">
      <template slot="name" slot-scope="text">
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>{{text}}</span>
          </template>
          {{text}}
        </a-tooltip>
      </template>
      <template slot="fixed" slot-scope="t">
        {{ t || t === 0 ? Number(t).toFixed(productLen) : t}}
      </template>
      <template slot="sort" slot-scope="t,r,i">
        {{ i + 1 }}
      </template>
      
      <template slot="typeName" slot-scope="t">
        <span v-if="t === '1'">新增</span>
        <span v-if="t === '2'">修改</span>
        <span v-if="t === '3'">删除</span>
        <span v-if="t === '4'">无变化</span>
      </template>
    </a-table>
    <h3 style="font-size: 14px;margin-top: 10px;font-weight: bold;">配料信息</h3>
    <a-table :columns="rawsColumns" :data-source="rawsList" :pagination="false" :scroll="{y: 300}">
      <template slot="name" slot-scope="text">
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>{{text}}</span>
          </template>
          {{text}}
        </a-tooltip>
      </template>
      <template slot="fixed" slot-scope="t">
        {{ t || t === 0 ? Number(t).toFixed(rawsLen) : t}}
      </template>
      <template slot="sort" slot-scope="t,r,i">
        {{ i + 1 }}
      </template>
      <template slot="typeName" slot-scope="t">
        <span v-if="t === '1'">新增</span>
        <span v-if="t === '2'">修改</span>
        <span v-if="t === '3'">删除</span>
        <span v-if="t === '4'">无变化</span>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
// import {mapState,mapMutations} from 'vuex'
import {productColumns,rawsColumns} from '../columns';
import api from '../api';
export default {
  components: {},
  props: ['viewVisible','rowData'],
  data() {
    return {
      productColumns,
      productList: [],
      rawsColumns,
      rawsList: [],
      productLen: 2,
      rawsLen: 3,
      productName: '',
      time: '',
    }
  },
  watch: {
    visible(val){
      if(val) this.getInfo()
    },
  },
  computed: {
    // ...mapState('product',['viewVisible','rowData']),
    visible: {
      get(){
        return this.viewVisible
      },
      set(){}
    },
    title(){
      return '变更信息'
    },
  },
  created() {},
  mounted() {},
  methods: {
    // ...mapMutations('product',['setState']),
    ok(){},
    cancel(){
      // this.setState({viewVisible: false,rowData: {}})
      this.$emit('close')
    },
    async getInfo(){
      console.log('this.rowData',this.rowData)
      this.time = this.rowData.ebsExecTime || ''
      this.productName = this.rowData.productName || ''
      let params = {current: 1,size: 1000,ebsId: this.rowData.ebsId}
      let productRes = await api.ebsformulaexecpro(params)
      this.productList = productRes?.data?.records || []
      let rawRes = await api.ebsformulaexecraw(params)
      this.rawsList = rawRes?.data?.records || []
    },
  },
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped></style>